import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function ChevronUpIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g id="chevron_up">
                <path id="vector" d="M22 15.975L20.225 17.75L12 9.52498L3.775 17.75L2 15.975L12 5.97498L22 15.975Z" />
            </g>
        </SvgIcon>
    );
}
